import { normalizeObject } from "./helper";
import axios from "axios";

const BASE_URL = "https://api.olamaps.io/places/v1/";
const OLA_PLACES_API_URL = `${BASE_URL}autocomplete`;
const OLA_REV_GEO_CODE_API_URL = `${BASE_URL}reverse-geocode`;

const TIMEOUT = 2000;

const AUTO_SUGGESTION_MAP = {
    search: "input",
    location: "location",
    radius: "radius"
};

class OlaSuggestion {
    getPlaces(request) {
        const params = normalizeObject(AUTO_SUGGESTION_MAP, request);
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.get(OLA_PLACES_API_URL, {
                    params: {
                        ...params,
                        api_key: process.env.OLA_PLACES_API_API_KEY
                    },
                    timeout: TIMEOUT
                });
                if (response && response.data && response.data.predictions) {
                    resolve(response.data.predictions);
                } else {
                    reject();
                }
            } catch (e) {
                reject(e);
            }
        });
    }

    getGeoCode(request) {
        return new Promise(async (resolve, reject) => {
            try {
                const { geometry } = request || {};
                const { location } = geometry || {};
                const { lat, lng } = location || {};
                const response = await axios.get(OLA_REV_GEO_CODE_API_URL, {
                    params: {
                        latlng: `${lat},${lng}`,
                        api_key: process.env.OLA_PLACES_API_API_KEY
                    },
                    timeout: TIMEOUT
                });
                if (response && response.data && response.data.results) {
                    resolve(response.data.results);
                } else {
                    reject();
                }
            } catch (e) {
                reject(e);
            }
        });
    }
}

export default OlaSuggestion;
